import _regeneratorRuntime from "babel-runtime/regenerator";

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import CloseButton from "../Misc/CloseButton";
import DefaultButton from "../Misc/Buttons/DefaultBlueButton";
import ProcessingModal from "../Misc/ProcessingModal";
import { withProvider, consumeContext } from "./VideoSettingsContext";
import Form from "./Form";
import ThumbnailPicker from "./ThumbnailPicker";
import { grabVideoFrame } from "./Utils";

var Settings = function (_React$Component) {
  _inherits(Settings, _React$Component);

  function Settings() {
    var _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, Settings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      isBusy: false
    }, _this.handleSubmit = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this$props$VideoSett, onSave, videoTitle, videoCaption, selectedFrame, videoSrc, _this$props, _this$props$thumbnail, thumbnailQuality, thumbnailMaxSize, decoration, thumbnail, decoratedThumbnail, decoratedThumbnailWithPlayButton;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.state.isBusy) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _this.setState({
                isBusy: true
              });

              _this$props$VideoSett = _this.props.VideoSettingsContext.state, onSave = _this$props$VideoSett.onSave, videoTitle = _this$props$VideoSett.videoTitle, videoCaption = _this$props$VideoSett.videoCaption, selectedFrame = _this$props$VideoSett.selectedFrame, videoSrc = _this$props$VideoSett.videoSrc;
              _this$props = _this.props, _this$props$thumbnail = _this$props.thumbnailQuality, thumbnailQuality = _this$props$thumbnail === undefined ? 1 : _this$props$thumbnail, thumbnailMaxSize = _this$props.thumbnailMaxSize, decoration = _this$props.decoration;

              if (!selectedFrame) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return grabVideoFrame(videoSrc, selectedFrame, thumbnailQuality, thumbnailMaxSize);

            case 8:
              _context.t0 = _context.sent;
              _context.next = 12;
              break;

            case 11:
              _context.t0 = null;

            case 12:
              thumbnail = _context.t0;

              if (!selectedFrame) {
                _context.next = 19;
                break;
              }

              _context.next = 16;
              return grabVideoFrame(videoSrc, selectedFrame, thumbnailQuality, thumbnailMaxSize, decoration);

            case 16:
              _context.t1 = _context.sent;
              _context.next = 20;
              break;

            case 19:
              _context.t1 = null;

            case 20:
              decoratedThumbnail = _context.t1;

              if (!selectedFrame) {
                _context.next = 27;
                break;
              }

              _context.next = 24;
              return grabVideoFrame(videoSrc, selectedFrame, thumbnailQuality, thumbnailMaxSize, decoration, true);

            case 24:
              _context.t2 = _context.sent;
              _context.next = 28;
              break;

            case 27:
              _context.t2 = null;

            case 28:
              decoratedThumbnailWithPlayButton = _context.t2;
              _context.next = 31;
              return onSave({
                videoTitle: videoTitle,
                videoCaption: videoCaption,
                thumbnail: thumbnail,
                decoratedThumbnail: decoratedThumbnail,
                decoratedThumbnailWithPlayButton: decoratedThumbnailWithPlayButton
              });

            case 31:
              _this.setState({
                isBusy: false
              });

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Settings.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        VideoSettingsContext = _props.VideoSettingsContext,
        rest = _objectWithoutProperties(_props, ["VideoSettingsContext"]);

    VideoSettingsContext.initializeState(rest);
  };

  Settings.prototype.render = function render() {
    var _props2 = this.props,
        _props2$thumbnailQual = _props2.thumbnailQuality,
        thumbnailQuality = _props2$thumbnailQual === undefined ? 1 : _props2$thumbnailQual,
        thumbnailMaxSize = _props2.thumbnailMaxSize;
    return React.createElement("div", {
      className: "recorder recorder--style-settings"
    }, React.createElement(CloseButton, {
      closeHandler: this.props.onClose
    }), React.createElement(ProcessingModal, {
      active: this.state.isBusy,
      title: "Processing"
    }), React.createElement("div", {
      className: "recorder__top-right"
    }, React.createElement(DefaultButton, {
      onClick: this.handleSubmit
    }, "done")), React.createElement("div", {
      className: "recorder__form"
    }, React.createElement(Form, null), React.createElement(ThumbnailPicker, {
      thumbnailMaxSize: thumbnailMaxSize,
      thumbnailQuality: thumbnailQuality
    })));
  };

  return Settings;
}(React.Component);

Settings.propTypes = process.env.NODE_ENV !== "production" ? {
  VideoSettingsContext: PropTypes.object.isRequired,
  videoSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  videoTitle: PropTypes.string,
  videoCaption: PropTypes.string,
  videoThumbnail: PropTypes.string,
  thumbnailQuality: PropTypes.number,
  thumbnailMaxSize: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  decoration: PropTypes.shape({
    logo: PropTypes.shape({
      url: PropTypes.string.isRequired,
      size: PropTypes.number,
      bottom: PropTypes.number,
      right: PropTypes.number,
      top: PropTypes.number,
      left: PropTypes.number
    }),
    overlay: PropTypes.object,
    customFrameSource: PropTypes.string
  })
} : {};
export default withProvider(consumeContext(Settings));